import React, { ReactNode } from 'react'
import { Container, Content, Header, Icon, Title } from './styled'

type Props = {
  children: ReactNode
  title: string
  icon: ReactNode | string
}

export const DefaultContent = ({ children, title, icon }: Props) => {
  return (
    <>
      <Container>
        <Header>
          <Icon>{icon}</Icon>
          <Title>{title}</Title>
        </Header>
        <Content>{children}</Content>
      </Container>
    </>
  )
}
